import { render, staticRenderFns } from "./coupon_mini.vue?vue&type=template&id=210fc5ff&scoped=true&"
import script from "./coupon_mini.vue?vue&type=script&lang=js&"
export * from "./coupon_mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fc5ff",
  null
  
)

export default component.exports